// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueLazyLoad from 'vue-lazyload'
import './assets/css/public.css'
import 'swiper/dist/css/swiper.min.css'
import './assets/js/rem.js'
import 'swiper/dist/js/swiper.min.js'
import { baseUrl } from './assets/js/common.js'

Vue.config.productionTip = false
//axios配置
axios.defaults.baseURL = baseUrl+'/api/';
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$axios = axios

if(process.env.NODE_ENV == 'development'){
    Vue.config.devtools = true
}else{
    Vue.config.devtools = false
}

//图片懒加载配置
Vue.use(VueLazyLoad,{
    error:require('./assets/images/placeholder.jpg'),
    loading:require('./assets/images/placeholder.jpg')
})

/* router.afterEach((to,from) => {
  //路由跳转页面时重置滚动条，回到顶部
  window.scrollTo(0,0);
}); */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js